import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'

import * as config from '@/config'
import * as define from '@/define'
import * as query from '@/queries/order'
import common from '@/utils/common'
import math from '@/utils/math'

export default {
  namespaced: true,
  state: {
    componentOpenState: []
  },
  getters: {
    orderDetail: (state) => {
      return state.orderDetail || {}
    },
    orderDatetime: (state) => {
      return state.orderDatetime
    },
    componentOpenState: (state) => (id) => {
      const setObject = _.get(state, `componentOpenState`, [])
      const targetValue = setObject.find((opentState) => opentState.id === id)
      if (targetValue == null) {
        return false
      } else {
        return targetValue.value
      }
    },
    taxInfo: (state) => {
      return state.taxInfo
    },
    siteCode: (state) => {
      return _.get(state.orderDetail, 'site.code', '')
    },
    items: (state) => {
      return _.chain(state.orderDetail)
        .get('shipments')
        .flatMap(val => val.items)
        .filter(val => val != null)
        .value()
    },
    giftItems: (state) => {
      return _.chain(state.orderDetail)
        .get('shipments')
        .flatMap(val => val.giftItems)
        .filter(val => val != null)
        .value()
    },
    shippingItems: (state) => {
      return _.chain(state.orderDetail)
        .get('shipments')
        .flatMap(val => val.shippingItems)
        .filter(val => val != null)
        .value()
    },
    paymentSetErrorCount: (state) => {
      return _.chain(state.orderDetail)
        .get('payments')
        .flatMap(val => val.paymentSets || [])
        .filter(val => val.statusCode === 9)
        .size()
        .value()
    }
  },
  actions: {
    async fetchOrderDetail ({ commit }, { siteCode, orderNo, orderDatetime }) {
      try {
        let param = common.addGraphQlCondition(
          query.GRAPH_QL_QUERY_ORDER_DETAIL,
          { siteCode: siteCode, orderNo: orderNo })
        param = common.addGraphQlCondition(
          param, { siteCode: siteCode, baseDateTime: orderDatetime })
        const res = await common.postGraphQl(param)
        commit('setOrderDetail', _.get(res, 'data.data.latestOrder'))
      } catch (error) {
        commit('setOrderDetail', null)
        throw error
      }
    },
    async fetchOrderDatetime ({ commit }, { siteCode, orderNo }) {
      try {
        const param = common.addGraphQlCondition(
          query.GRAPH_QL_QUERY_ORDER_DATETIME,
          { siteCode: siteCode, orderNo: orderNo })
        const res = await common.postGraphQl(param)
        commit('setOrderDatetime', _.get(res, 'data.data.latestOrder.orderDatetime'))
      } catch (error) {
        commit('setOrderDatetime', null)
        throw error
      }
    },
    async fetchTaxInfo ({ commit }, { siteCode, baseDatetime = moment().utc().format(), type = define.TAX_RATE_TYPE.NORMAL }) {
      try {
        const param = common.addGraphQlCondition(
          query.GRAPH_QL_QUERY_TAXES,
          { siteCode: siteCode, baseDateTime: baseDatetime, type: type })
        const res = await common.postGraphQl(param)
        commit('setTaxInfo', _.get(res, 'data.data.taxes[0]'))
      } catch (error) {
        commit('setTaxInfo', null)
        throw error
      }
    },
    manageComponentOpenState ({ commit }, id) {
      commit('setComponentOpenState', id)
    },
    async setOrderDetail ({ commit }, payload) {
      commit('setOrderDetail', payload)
    },
    async calculateTotal ({ commit, state }) {
      const items = _.chain(state)
        .get('orderDetail.shipments')
        .flatMap(val => {
          return _.concat([],
            val.items,
            val.giftItems,
            val.shippingItems)
        })
        .filter(val => val != null)
        .value()
      const prices = _.chain(items)
        .map('price.gross')
        .filter(val => val != null)
        .value()
      const adjustmentPrices = _.chain(items)
        .flatMap(val => val.priceAdjustments)
        .filter(val => val != null && val.delete !== 1)
        .map('price.gross')
        .filter(val => val != null)
        .value()
      const merchandiseAdjustmentPrices = _.chain(state)
        .get('orderDetail.merchandisePriceAdjustments')
        .filter(val => val.delete !== 1)
        .map('price.gross')
        .filter(val => val != null)
        .value()

      const gross = math.add(
        _.concat([], prices, adjustmentPrices, merchandiseAdjustmentPrices),
        config.ORDER_CONFIG.price.roundType,
        config.ORDER_CONFIG.price.decimalDigit)
      commit('setOrderTotalPrice', { gross })
    }
  },
  mutations: {
    setOrderDetail (state, payload) {
      Vue.set(state, 'orderDetail', payload)
    },
    setOrderDatetime (state, payload) {
      Vue.set(state, 'orderDatetime', payload)
    },
    setTaxInfo (state, payload) {
      Vue.set(state, 'taxInfo', payload)
    },
    setComponentOpenState (state, id) {
      const setObject = _.get(state, `componentOpenState`, [])
      const targetValue = setObject.find((opentState) => opentState.id === id)
      if (targetValue == null) {
        setObject.push({ id, value: true })
      } else {
        targetValue.value = !targetValue.value
      }
      Vue.set(state, `componentOpenState`, setObject)
    },
    setOrderTotalPrice (state, payload) {
      if (state.orderDetail == null) {
        return
      }
      if (state.orderDetail.orderTotalPrice == null) {
        Vue.set(state.orderDetail, 'orderTotalPrice', { net: 0, gross: 0 })
      }
      if (_.has(payload, 'net')) {
        Vue.set(state.orderDetail.orderTotalPrice, 'net', payload.net)
      }
      if (_.has(payload, 'gross')) {
        Vue.set(state.orderDetail.orderTotalPrice, 'gross', payload.gross)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/pages/orderDetail.js